<xs-existing-attachment-activity
  *ngIf="!error && isActivityInitialised()"
  [parentActivity]="activity"
  [canEdit]="canEdit"
  [canDelete]="canEdit"
  [isSPPMode]="isSPPMode"
  [activityCtrl]="activityCtrl"
  (onDelete)="delete()"
  (onError)="setError(error, canRetry)"
></xs-existing-attachment-activity>

<div class="container" *ngIf="showDescription()">
  <div class="description" id="Note_Div_{{ activity.activityId }}" [ngClass]="isShowMore ? 'show-more' : 'show-less'">
    {{ captureDescription }}
  </div>

  <div *ngIf="isLargeDescription(activity.activityId)">
    <span class="more-less" (click)="toggleShowMore()">
      {{ isShowMore ? 'Show more' : 'Show less' }}
    </span>
  </div>
</div>

<xs-attachment-note
  *ngIf="!error"
  [parentActivity]="activity"
  [activityCtrl]="activityCtrl"
  (updateEditing)="updateEditing($event)"
  (saveNote)="saveNote($event)"
  [canEdit]="canEdit"
  [error]="error"
>
</xs-attachment-note>

<!-- Attachment error -->
<div class="attachment-error-footer" *ngIf="error">
  <div class="attachment-error-caption">{{ 'attachment_Error' | xsI18n : error }}</div>
  <div class="error-buttons">
    <div class="cancel-button" type="button" (click)="cancel()" [hidden]="!canRetry">
      {{ 'xs_cancel_label' | xsI18n }}
    </div>
    <div class="retry-button" type="button" (click)="retry()" [hidden]="!canRetry">
      {{ 'attachment_Retry_Button' | xsI18n }}
    </div>
    <div class="ok-button" type="button" (click)="clearError()" [hidden]="canRetry">
      {{ 'attachment_OK_Caption' | xsI18n }}
    </div>
  </div>
</div>
